import NotFoundImagePlaceholder from "../../Assets/images/illustrations/date_picker_drawing.svg";
import {parseStringToDateTimeWithDayjs} from "../../Utils/DateHelper";
import dayjs from "dayjs";
import {RegularSwitch} from "../Form/RegularSwitch";
import {useTranslation} from "react-i18next";
import {useBoundStore} from "../../Store/store";

export const ShiftInfoCard = (props) => {
    const {
        shift,
        overrideImage = null,
        onPublishedChange = null,
        onBreakDurationChange = null,
        readOnly = false,
    } = props;

    const {t} = useTranslation();
    const user = useBoundStore(state => state.user);

    const displayedStatuten = (() => {
        const allowed = shift?.allowed_statuten ?? [];
        if (user?.type !== 'freelancer') return allowed;
        const mine = [user?.main_statuut, ...(user?.extra_statuten || [])].filter(Boolean);
        return allowed.filter(s => mine.includes(s));
    })();

    return (
        <div className={'border border-gray-200 rounded-lg m-2'}>
            <div className={'p-4'}>
                <img src={overrideImage ? overrideImage : shift?.image ?? NotFoundImagePlaceholder} alt={shift?.title} className={'w-full h-40 object-contain rounded-lg'}/>

                {onPublishedChange && (
                    <div className={`mt-4 flex items-center justify-between ${readOnly ? 'opacity-50 cursor-not-allowed' : ''}`}>
                        <span className={'font-bold text-sm'}>{t('shifts.published')}:</span>
                        <RegularSwitch
                            value={shift?.is_published ?? false}
                            setValue={(newValue) => {
                                if (!readOnly) {
                                    onPublishedChange(newValue);
                                }
                            }}
                            disabled={readOnly}
                        />
                    </div>
                )}

                <table className={'mt-4 border-spacing-4'}>
                    <tbody>
                    <tr>
                        <td className={'font-bold pr-4'}>{t('shifts.company')}:</td>
                        <td>{shift?.branch?.company_name}</td>
                    </tr>
                    <tr>
                        <td className={'font-bold pr-4'}>{t('shifts.freelancer')}:</td>
                        <td>{shift?.freelancer?.first_name ?? '-'} {shift?.freelancer?.last_name ?? ''}</td>
                    </tr>
                    {displayedStatuten.length > 0 && (
                        <tr>
                            <td className={'font-bold pr-4 align-top'}>{t('shifts_module.column_allowed_statuten')}:</td>
                            <td>
                                <div className="flex flex-wrap gap-1">
                                    {displayedStatuten.map(s => (
                                        <span key={s} className="text-xs bg-gray-100 text-gray-800 px-2 py-0.5 rounded">
                                            {t(`statuten.${s}`, s)}
                                        </span>
                                    ))}
                                </div>
                            </td>
                        </tr>
                    )}
                    <tr>
                        <td className={'font-bold pr-4'}>{t('shifts.from')}:</td>
                        <td>{parseStringToDateTimeWithDayjs(shift?.start_time)}</td>
                    </tr>
                    <tr>
                        <td className={'font-bold pr-4'}>{t('shifts.to')}:</td>
                        <td>{parseStringToDateTimeWithDayjs(shift?.end_time)}</td>
                    </tr>
                    <tr>
                        <td className={'font-bold pr-4'}>{t('shifts.total_time')}:</td>
                        <td>{dayjs.duration(shift?.total_time, 'minutes').humanize()}</td>
                    </tr>
                    <tr>
                        <td className={'font-bold pr-4'}>{t('shifts.total_break')}:</td>
                        <td>
                            {readOnly || !onBreakDurationChange ? (
                                shift?.break_duration === null ? '-' : dayjs.duration(shift?.break_duration, 'minutes').humanize()
                            ) : (
                                <div className="flex items-center gap-2">
                                    <input
                                        type="number"
                                        min="0"
                                        value={shift?.break_duration ?? 0}
                                        onChange={(e) => {
                                            const newValue = parseInt(e.target.value) || 0;
                                            onBreakDurationChange(newValue);
                                        }}
                                        className="w-20 px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    />
                                    <span className="text-sm text-gray-600">{t('shifts.minutes')}</span>
                                </div>
                            )}
                        </td>
                    </tr>
                    </tbody>
                </table>

                <p className={'mt-4 font-bold text-sm'}>{t('shifts.remark')}:</p>
                <p className={'text-sm mt-0'}>
                    {shift?.remarks ?? '-'}
                </p>
            </div>
        </div>
    )
}